"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearHydration = exports.MonthHydration = exports.WeekHydration = exports.createUserHydrationSchema = exports.YearHistorySchema = exports.monthsNum = exports.MonthHistorySchema = exports.weeksNum = exports.WeekHistorySchema = exports.AggregationSchema = exports.StatsAggregationKind = exports.UserLoyaltyProgramStatus = exports.UserDispensingStatsItem = exports.UserManualDispensingHistoryItem = exports.UserWithTenant = exports.User = exports.RelationId = exports.Id = exports.AylaEndUserAuth = exports.GenericLinkedExternalAccount = exports.isUserRole = exports.isClientAppManagementRole = exports.isDealerRole = exports.isDataManagementRole = exports.isSystemRole = exports.getAssignableUserRoles = exports.expandUserRoleGroup = exports.groupGlobalUserRole = exports.AssignableUserRoleError = exports.DeprecatedUserRoleError = exports.UserRoleGroup = exports.AssignableUserRole = exports.DeprecatedUserRole = exports.GlobalUserRole = exports.BasicUserRole = exports.DealerUserRole = exports.DataManagementUserRole = exports.ClientAppManagementUserRole = exports.SystemManagementUserRole = exports.ExternalDealerToolsUserRole = exports.NAMESPACE = exports.Privacy = exports.Loyalty = void 0;
const effect_1 = require("effect");
const date_1 = require("../../date");
const entity_1 = require("../../entity");
const Json = __importStar(require("../../json"));
const net_1 = require("../../net");
const array_1 = require("../../utils/array");
const Tenant = __importStar(require("../tenant"));
const loyalty_1 = require("./loyalty");
const privacy_1 = require("./privacy");
exports.Loyalty = __importStar(require("./loyalty"));
exports.Privacy = __importStar(require("./privacy"));
exports.NAMESPACE = 'Culligan.User';
exports.ExternalDealerToolsUserRole = effect_1.Schema.Enums({
    /** Editor: can edit and view data. */
    Edit: 'edit',
    /** Viewer: can only view data. */
    View: 'view',
}).annotations({
    identifier: `${exports.NAMESPACE}.ExternalDealerToolsUserRole`,
    description: 'Roles for external dealer tools (dashboards, apps)',
});
exports.SystemManagementUserRole = effect_1.Schema.Enums({
    /**
     * System Administrator
     * Scope:
     * - Brands: all access
     * - Regions: all access
     * Has full control over the system and data.
     * Can change the application settings and
     * manage resources system-wide.
     */
    SystemAdmin: 'sysAdmin',
}).annotations({
    identifier: `${exports.NAMESPACE}.SystemManagementUserRole`,
    description: 'User roles with top level system management permissions that apply globally to all services and applications in the Culligan IoT ecosystem',
});
exports.ClientAppManagementUserRole = effect_1.Schema.Enums({
    /**
     * Client App Administrator
     * Scope:
     * - Brands: limited
     * - Regions: all access or limited
     * Has read access to the data of users who
     * used the listed client applications and
     * full control on the user-client-app data
     * (check the `clientAppsMgmtConfiguration`
     * field of each `user` for details).
     */
    ClientAppAdmin: 'clientAppAdmin',
}).annotations({
    identifier: `${exports.NAMESPACE}.ClientAppManagementUserRole`,
    description: 'User roles with client application management permissions that apply globally to all services and applications in the Culligan IoT ecosystem',
});
exports.DataManagementUserRole = effect_1.Schema.Enums({
    ...exports.SystemManagementUserRole.enums,
    ...exports.ClientAppManagementUserRole.enums,
    /**
     * Administrator
     * Scope:
     * - Brands: all access
     * - Regions: all access
     * Has full control over the data.
     * Can manage users, devices and data for
     * all brands and models.
     */
    Admin: 'admin',
    /**
     * Brand Manager
     * Scope:
     * - Brands: limited
     * - Regions: all access or limited
     * Has full control over the data belonging
     * to a brand. Can manage users, devices and
     * data for all models of the selected brand.
     */
    BrandManager: 'brandManager',
    /**
     * Brand Technical Operator
     * Scope:
     * - Brands: limited
     * - Regions: all access or limited
     * Has read-only access to the data
     * belonging to a single a brand.
     * Can read users, devices and data to
     * provide support.
     * Can edit users, initiate password
     * resets.
     */
    BrandTechOperator: 'brandTechOperator',
    /**
     * Brand Support Operator
     * Scope:
     * - Brands: limited
     * - Regions: all access or limited
     * Has read-only access to the data
     * belonging to a single a brand.
     * Can read users, devices and data to
     * provide support.
     */
    BrandSupportOperator: 'brandSupportOperator',
}).annotations({
    identifier: `${exports.NAMESPACE}.DataManagementUserRole`,
    description: 'User roles with data management permissions that apply globally to all services and applications in the Culligan IoT ecosystem',
});
exports.DealerUserRole = effect_1.Schema.Enums({
    /**
     * Dealer
     * Scope: dealership (dealer "location")
     * Has full control on the devices they
     * have installed and all Dealer data.
     */
    Dealer: 'dealer',
    /**
     * Dealer Service Technician
     * Scope: dealership (dealer "location")
     * Has limited control on the devices the
     * dealership have installed and the data.
     */
    DealerTechnician: 'dealerTechnician',
}).annotations({
    identifier: `${exports.NAMESPACE}.DealerUserRole`,
    description: 'Dealer user roles that apply globally to all services and applications in the Culligan IoT ecosystem',
});
exports.BasicUserRole = effect_1.Schema.Enums({
    /**
     * User
     * Scope: owned or shared resources
     * Has full control over owned devices and
     * limited control over shared devices
     * (check the `sharingConfiguration` field
     * of each `device` for details).
     */
    User: 'user',
}).annotations({
    identifier: `${exports.NAMESPACE}.BasicUserRole`,
    description: 'Basic user roles with permissions limited to owned resources that apply globally to all services and applications in the Culligan IoT ecosystem',
});
exports.GlobalUserRole = effect_1.Schema.Enums({
    ...exports.DataManagementUserRole.enums,
    ...exports.DealerUserRole.enums,
    ...exports.BasicUserRole.enums,
}).annotations({
    identifier: `${exports.NAMESPACE}.GlobalUserRole`,
    description: 'All user roles that apply globally to all services and applications in the Culligan IoT ecosystem',
});
exports.DeprecatedUserRole = effect_1.Schema.Enums(effect_1.Struct.pick(exports.GlobalUserRole.enums, 'ClientAppAdmin', 'BrandManager')).annotations({
    identifier: `${exports.NAMESPACE}.DeprecatedUserRole`,
    description: 'User roles that are deprecated and no longer used',
});
exports.AssignableUserRole = effect_1.Schema.Enums(effect_1.Struct.omit(exports.GlobalUserRole.enums, ...effect_1.Struct.keys(exports.DeprecatedUserRole.enums))).annotations({
    identifier: `${exports.NAMESPACE}.AssignableUserRole`,
    description: 'All non-deprecated user roles',
});
exports.UserRoleGroup = effect_1.Schema.Literal('sysAdmin', 'admin', 'productSupport', 'customerSupport', 'technician').annotations({
    identifier: `${exports.NAMESPACE}.UserRoleGroup`,
    description: 'The user roles used in culligan-one-dashboard',
});
class DeprecatedUserRoleError extends effect_1.Data.TaggedError('DeprecatedUserRoleError') {
    message = 'the role is deprecated and should not be used';
}
exports.DeprecatedUserRoleError = DeprecatedUserRoleError;
class AssignableUserRoleError extends effect_1.Data.TaggedError('AssignableUserRoleError') {
    message = 'the user is not authorized to assign one or more of the requested roles';
}
exports.AssignableUserRoleError = AssignableUserRoleError;
exports.groupGlobalUserRole = effect_1.Match.type().pipe(effect_1.Match.withReturnType(), effect_1.Match.when('sysAdmin', () => effect_1.Effect.succeed(effect_1.Option.some('sysAdmin'))), effect_1.Match.whenOr('admin', 'dealer', () => effect_1.Effect.succeed(effect_1.Option.some('admin'))), effect_1.Match.when('brandTechOperator', () => effect_1.Effect.succeed(effect_1.Option.some('productSupport'))), effect_1.Match.when('brandSupportOperator', () => effect_1.Effect.succeed(effect_1.Option.some('customerSupport'))), effect_1.Match.when('dealerTechnician', () => effect_1.Effect.succeed(effect_1.Option.some('technician'))), 
// the "user" role should be hidden in culligan-one-dashboard
effect_1.Match.when('user', () => effect_1.Effect.succeed(effect_1.Option.none())), effect_1.Match.whenOr('clientAppAdmin', 'brandManager', deprecatedRole => effect_1.Effect.fail(new DeprecatedUserRoleError({ cause: deprecatedRole }))), effect_1.Match.exhaustive);
exports.expandUserRoleGroup = effect_1.Match.type().pipe(effect_1.Match.withReturnType(), effect_1.Match.when('sysAdmin', () => ['sysAdmin']), effect_1.Match.when('admin', () => ['admin', 'dealer']), effect_1.Match.when('productSupport', () => ['brandTechOperator']), effect_1.Match.when('customerSupport', () => ['brandSupportOperator']), effect_1.Match.when('technician', () => ['dealerTechnician']), effect_1.Match.exhaustive);
const getAssignableUserRoles = (userRole) => {
    const assignableRoles = effect_1.Record.values(exports.AssignableUserRole.enums);
    return effect_1.Match.value(userRole).pipe(effect_1.Match.withReturnType(), effect_1.Match.when('sysAdmin', () => effect_1.Effect.succeed(assignableRoles)), effect_1.Match.when('admin', () => effect_1.Effect.succeed((0, array_1.except)(assignableRoles)(['sysAdmin']))), effect_1.Match.when('dealer', () => effect_1.Effect.succeed(['dealer', 'dealerTechnician', 'user'])), effect_1.Match.whenOr('dealerTechnician', 'brandTechOperator', 'brandSupportOperator', 'user', () => effect_1.Effect.succeed([])), effect_1.Match.whenOr('clientAppAdmin', 'brandManager', deprecatedRole => effect_1.Effect.fail(new DeprecatedUserRoleError({ cause: deprecatedRole }))), effect_1.Match.exhaustive);
};
exports.getAssignableUserRoles = getAssignableUserRoles;
/**
 * Returns `true` if the specified role
 * is in the System Administration group.
 * @param {unknown} role Role
 */
exports.isSystemRole = effect_1.Schema.is(exports.SystemManagementUserRole);
/**
 * Returns `true` if the specified role
 * is in the Data Management (Admin) group.
 * @param {unknown} role Role
 */
exports.isDataManagementRole = effect_1.Schema.is(exports.DataManagementUserRole);
/**
 * Returns `true` if the specified role
 * is in the Dealer group.
 * @param {unknown} role Role
 */
exports.isDealerRole = effect_1.Schema.is(exports.DealerUserRole);
/**
 * Returns `true` if the specified role
 * is in the Client App Management (Admin) group.
 * @param {unknown} role Role
 */
exports.isClientAppManagementRole = effect_1.Schema.is(exports.ClientAppManagementUserRole);
/**
 * Returns `true` if the specified role
 * is in the User group.
 * @param {unknown} role Role
 */
exports.isUserRole = effect_1.Schema.is(exports.BasicUserRole);
exports.GenericLinkedExternalAccount = Json.Record.annotations({
    identifier: `${exports.NAMESPACE}.GenericLinkedExternalAccount`,
    description: 'A generic representation of a linked external account',
});
exports.AylaEndUserAuth = effect_1.Schema.Struct({
    email: effect_1.Schema.String,
    token: effect_1.Schema.String,
    uuid: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.AylaEndUserAuth`,
    description: 'A linked external account for Ayla end user authentication',
});
const PrivacyConsentSummary = effect_1.Schema.Struct({
    [privacy_1.ConsentCategory.enums.Global]: effect_1.Schema.optionalWith(effect_1.Schema.partialWith(effect_1.Schema.Record({ key: privacy_1.GlobalConsentType, value: effect_1.Schema.Boolean }), { exact: true }), { exact: true, default: () => ({}) }),
    [privacy_1.ConsentCategory.enums.Loyalty]: effect_1.Schema.optionalWith(effect_1.Schema.Record({ key: effect_1.Schema.String, value: effect_1.Schema.Boolean }), {
        exact: true,
        default: () => ({}),
    }),
});
exports.Id = effect_1.Schema.NonEmptyString.pipe(effect_1.Schema.pattern(/^[a-zA-Z0-9]+$/)).annotations({
    description: 'An automatically-generated unique identifier (ID)',
    identifier: `${exports.NAMESPACE}.Id`,
});
exports.RelationId = effect_1.Schema.TemplateLiteralParser(exports.Id, '-', date_1.Timestamp13FromString).annotations({
    identifier: `${exports.NAMESPACE}.RelationId`,
    description: 'Identifier for records relating to a user, based on pattern UserId-Timestamp',
});
exports.User = effect_1.Schema.Struct({
    ...entity_1.BaseTimestampedEntity.fields,
    id: exports.Id,
    tenantId: effect_1.Schema.optionalWith(Tenant.Id, { exact: true, nullable: true, as: 'Option' }).annotations({
        description: 'The tenant that this user belongs to, if any',
    }),
    firstName: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({ description: 'First name' }),
    lastName: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({ description: 'Last name' }),
    country: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({ description: 'Country of residence' }),
    mobilePhoneNumber: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true, nullable: true }).annotations({
        description: 'Mobile phone number',
    }),
    address: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true, nullable: true }).annotations({
        description: 'Street address',
    }),
    addressExtra: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true, nullable: true }).annotations({
        description: 'Extra address information',
    }),
    city: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true, nullable: true }).annotations({
        description: 'City',
    }),
    zip: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true, nullable: true }).annotations({
        description: 'ZIP code',
    }),
    state: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true, nullable: true }).annotations({
        description: 'State, provice, region (as applicable in the country of residence)',
    }),
    countryCode: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true, nullable: true }).annotations({
        description: 'ISO 3166 Alpha-3 country code',
    }),
    dealerId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true, nullable: true }).annotations({
        description: 'ID of the reference Dealer for the Customer User',
    }),
    dealerIds: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true, nullable: true }).annotations({
        description: 'IDs of the Dealerships (a.k.a. "Locations") that a Dealer User belongs to',
    }),
    dealerToolsRole: effect_1.Schema.optionalWith(exports.ExternalDealerToolsUserRole, { exact: true, nullable: true }),
    accountNumber: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true, nullable: true }).annotations({
        description: 'Dealer Account Number of the Customer User',
    }),
    globalRoles: effect_1.Schema.Array(exports.GlobalUserRole),
    email: effect_1.Schema.propertySignature(net_1.Email).annotations({ description: 'E-mail address' }),
    externalUserId: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'User ID on the "main" third-party Identity Provider',
    }),
    passwordChangedAt: effect_1.Schema.optionalWith(date_1.TolerantValidDateFromIso8601String, {
        exact: true,
        nullable: true,
        as: 'Option',
    }).annotations({
        description: 'User last password change date',
    }),
    // `lastLoginAt` should be optional because it's missing for some users on prod
    lastLoginAt: effect_1.Schema.optionalWith(date_1.TolerantValidDateFromIso8601String, {
        exact: true,
        nullable: true,
        as: 'Option',
    }).annotations({
        description: 'User last login date',
    }),
    region: effect_1.Schema.optionalWith(effect_1.Schema.String, {
        exact: true,
        nullable: true,
        default: () => 'default',
    }).annotations({ description: 'User region' }),
    linkedExternalAccounts: effect_1.Schema.optionalWith(effect_1.Schema.Record({ key: effect_1.Schema.String, value: effect_1.Schema.Union(exports.GenericLinkedExternalAccount, exports.AylaEndUserAuth) }), { exact: true, nullable: true, default: () => ({}) }).annotations({ description: 'Linked accounts on third-party Identity Providers' }),
    appIds: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true, nullable: true, default: () => [] }),
    privacyConsent: effect_1.Schema.optionalWith(PrivacyConsentSummary, {
        exact: true,
        nullable: true,
        default: () => ({ global: {}, loyalty: {} }),
    }).annotations({ description: 'Privacy Consent Tracking' }),
}).annotations({
    identifier: `${exports.NAMESPACE}.User`,
    description: 'User profile',
});
exports.UserWithTenant = effect_1.Schema.extend(exports.User, effect_1.Schema.Struct({
    tenant: effect_1.Schema.optionalWith(Tenant.Tenant, {
        exact: true,
        nullable: true,
        as: 'Option',
    }),
})).annotations({
    identifier: `${exports.NAMESPACE}.UserWithTenant`,
    description: 'User profile with tenant',
});
exports.UserManualDispensingHistoryItem = effect_1.Schema.extend(entity_1.BaseTimestampedEntity, effect_1.Schema.Struct({ id: exports.RelationId, userId: exports.Id, clientAppId: effect_1.Schema.String, drinkSize: effect_1.Schema.Number })).annotations({
    identifier: `${exports.NAMESPACE}.UserManualDispensingHistoryItem`,
    description: 'Item from the history of the manual dispensing events for a User',
});
exports.UserDispensingStatsItem = effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Automatically generated unique identifier (ID)',
    }),
    userId: exports.Id,
    day: date_1.TimelessDateFromTimelessUtcIsoDateString,
    totalVolume: effect_1.Schema.propertySignature(effect_1.Schema.Positive).annotations({
        description: 'Total volume dispensed',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.UserDispensingStatsItem`,
    description: 'Daily, Weekly or Monthly statistics of dispensing for a User',
});
exports.UserLoyaltyProgramStatus = effect_1.Schema.extend(entity_1.BaseTimestampedEntity, effect_1.Schema.Struct({
    userId: exports.Id,
    loyaltyProgramId: loyalty_1.LoyaltyProgramId,
    points: effect_1.Schema.propertySignature(effect_1.Schema.Positive).annotations({
        description: 'Current points of the user',
    }),
})).annotations({
    identifier: `${exports.NAMESPACE}.UserLoyaltyProgramStatus`,
    description: 'Status of a Loyalty Program for a subscribed User',
});
exports.StatsAggregationKind = effect_1.Schema.Enums({
    Week: 'week',
    Month: 'month',
    Year: 'year',
}).annotations({
    identifier: `${exports.NAMESPACE}.StatsAggregationKind`,
    description: 'Kinds of aggregation for user stats',
});
exports.AggregationSchema = effect_1.Schema.Struct({
    aggregation: exports.StatsAggregationKind,
    year: effect_1.Schema.String,
    month: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    week: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    weekStart: effect_1.Schema.optionalWith(effect_1.Schema.Literal('monday', 'sunday'), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.AggregationSchema`,
});
exports.WeekHistorySchema = effect_1.Schema.Struct({
    monday: effect_1.Schema.Number,
    tuesday: effect_1.Schema.Number,
    wednesday: effect_1.Schema.Number,
    thursday: effect_1.Schema.Number,
    friday: effect_1.Schema.Number,
    saturday: effect_1.Schema.Number,
    sunday: effect_1.Schema.Number,
}).annotations({
    identifier: `${exports.NAMESPACE}.WeekHistorySchema`,
    description: 'Hydration history for each day of the week',
});
exports.weeksNum = effect_1.Schema.Literal('1', '2', '3', '4').annotations({
    identifier: `${exports.NAMESPACE}.weeksNum`,
});
exports.MonthHistorySchema = effect_1.Schema.Record({ key: exports.weeksNum, value: effect_1.Schema.NonNegative }).annotations({
    identifier: `${exports.NAMESPACE}.MonthHistorySchema`,
    description: 'Hydration history for each day of the month',
});
exports.monthsNum = effect_1.Schema.Literal('1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12').annotations({
    identifier: `${exports.NAMESPACE}.monthsNum`,
});
exports.YearHistorySchema = effect_1.Schema.Record({ key: exports.monthsNum, value: effect_1.Schema.NonNegative }).annotations({
    identifier: `${exports.NAMESPACE}.YearHistorySchema`,
    description: 'Hydration history for each month of the year',
});
const createUserHydrationSchema = (schema) => effect_1.Schema.extend(entity_1.BaseTimestampedEntity, effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Automatically generated unique identifier (ID)',
    }),
    hydration: effect_1.Schema.Struct({ average: effect_1.Schema.Number, total: effect_1.Schema.Number, history: schema }),
}));
exports.createUserHydrationSchema = createUserHydrationSchema;
exports.WeekHydration = (0, exports.createUserHydrationSchema)(exports.WeekHistorySchema).annotations({
    identifier: `${exports.NAMESPACE}.WeekHydration`,
    description: 'Weekly hydration history for a User',
});
exports.MonthHydration = (0, exports.createUserHydrationSchema)(exports.MonthHistorySchema).annotations({
    identifier: `${exports.NAMESPACE}.MonthHydration`,
    description: 'Monthly hydration history for a User',
});
exports.YearHydration = (0, exports.createUserHydrationSchema)(exports.YearHistorySchema).annotations({
    identifier: `${exports.NAMESPACE}.YearHydration`,
    description: 'Yearly hydration history for a User',
});
//# sourceMappingURL=index.js.map